var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 14.8438C45.3125 20.125 41.1152 24.4062 35.9375 24.4062C35.6679 24.4062 35.4011 24.3946 35.1373 24.3719C32.8968 24.1787 30.42 24.5236 28.9906 26.294L14.0923 44.7465C13.0841 45.9953 11.5812 46.7188 9.99518 46.7188C7.06383 46.7188 4.6875 44.2949 4.6875 41.3049C4.6875 39.6872 5.39676 38.1542 6.62105 37.1258L24.7118 21.9296C26.4475 20.4716 26.7856 17.9453 26.5962 15.66C26.5739 15.3909 26.5625 15.1187 26.5625 14.8438C26.5625 9.56253 30.7598 5.28125 35.9375 5.28125C37.3132 5.28125 38.6197 5.5835 39.7967 6.12644L32.9712 13.0884C33.5048 15.4592 35.3344 17.3254 37.6587 17.8697L44.4841 10.9078C45.0162 12.1082 45.3125 13.4407 45.3125 14.8438Z",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1401 41.1407H10.1557V41.1567H10.1401V41.1407Z",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidro);
export default __webpack_public_path__ + "static/media/hidro.f87504d868735d94f45ec718576ea4b1.svg";
export { ForwardRef as ReactComponent };